import { IEntityTypeIdentifier } from "@rightship-tech/common-ui/models/basic.models";

export interface UserPermissionModel {
    permissionId: number;
    category: string;
    categoryId: number;
    parameters: string;
    permissionMappingType: number;
    permission: string;
}

export interface RefreshTokenRequest {
    refreshToken: string;
}

export interface TokenRequest {
    email: string;
    password: string;
}

export interface ProviderTokenRequest {
    email: string;
    firstName: string;
    lastName: string;
    providerKey: string;
    providerName: string;
    subProviderName: string;
    providerAccessToken: string;
    metadata: string;
    createIfNotExist: boolean;
    doNotSaveUserLogin: boolean;
}

export interface RegisterTokenRequest {
    name: string;
    surname: string;
    email: string;
    password: string;
    confirmPassword: string;
}

export interface ValidateTwoFactAuthCodeRequest {
    code: string
}

export interface TokenResponse {
    token: string;
    refreshToken: string;
    userId: number;
    roleId: number;
    expiration: Date;
    claims: UserPermissionModel[];
}

export interface UserPasswordPolicy {
    minimumLength: number;
    minimumNumberOfDigits: number;
    minimumNumberOfUpperCaseLetters: number;
    minimumNumberOfLowerCaseLetters: number;
    passwordCannotMatchUsername: number;
    minimumNumberSpecialCharacters: number;
}

export interface RefreshTokenResponse extends TokenResponse {

}

export interface Auth0Settings {
    domain: string;
    clientID: string;
    redirectUri: string;
    audience: string;
}

export interface RoleMetaModel {
    roleId: number;
    roleName: string;
    departentName: string;
    impersonationId?: number;
}

export interface UserSecurityInfoModel {
    allowedClaims: UserPermissionModel[];
    roleId: number;
    departmentId: number;
    id: number;
    isManager?: boolean;
    managerId?: number;
    roles: RoleMetaModel[];
    departmentName: string;
    roleName: string;
    userName: string;
    campaign?: string;
    campaignIdentifier?: string;
    campaignSource?: string;
    campaignMedium?: string;
    branchId: number;
    branchName: string;
    email: string;
    accessibleDepartmentIds: number[];
    settings?: any;
    userPhoneNumbers?: UserPhoneNumber[];
    timezone?: string;
    cultureCode?: string;
    createdDate?: Date;
    intercomHash: string;
}

export interface UserPhoneNumber extends IEntityTypeIdentifier {
    userId: number;
    phoneId: string;
    phoneNumber: string;
    phoneNumberTypeId: number;
    phoneSequence: number;
}

export interface SwitchRoleResponse {
    tokenResponse: TokenResponse;
    userSecurityInfo: UserSecurityInfoModel;
}

export const AuthenticationMessageKey = 'authentication-message';
